export const SHARE_REPORT_SELECTOR_PANEL_HEIGHT = 450


// WEBPACK FOOTER //
// ./web/js/controls/constants.js